import { years } from 'owa-locstrings/lib/strings/years.locstring.json';
import { year } from 'owa-locstrings/lib/strings/year.locstring.json';
import { months } from 'owa-locstrings/lib/strings/months.locstring.json';
import { month } from 'owa-locstrings/lib/strings/month.locstring.json';
import { weeks } from 'owa-locstrings/lib/strings/weeks.locstring.json';
import { week } from 'owa-locstrings/lib/strings/week.locstring.json';
import { days } from 'owa-locstrings/lib/strings/days.locstring.json';
import { day } from 'owa-locstrings/lib/strings/day.locstring.json';
import loc from 'owa-localize';

import RecurrenceConstants from 'owa-recurrence-utils/lib/RecurrenceTypes';
import { IDropdownOption } from '@fluentui/react/lib/Dropdown';

// Contains all the base options for the recurrence repeat interval
export default function getIntervalUnitMenuItems(interval: number): IDropdownOption[] {
    const isMultiInterval = interval > 1;
    return [
        {
            key: RecurrenceConstants.Daily,
            text: !isMultiInterval ? loc(day) : loc(days),
        },
        {
            key: RecurrenceConstants.Weekly,
            text: !isMultiInterval ? loc(week) : loc(weeks),
        },
        {
            key: RecurrenceConstants.Monthly,
            text: !isMultiInterval ? loc(month) : loc(months),
        },
        {
            key: RecurrenceConstants.Yearly,
            text: !isMultiInterval ? loc(year) : loc(years),
        },
    ] as IDropdownOption[];
}
